// What the Browse search box searches.
//
// Shared because both halves need the same list: the server-rendered dropdown
// (`views/pages/Front.tsx`), the browser code that puts the choice in the payload
// (`features/navigation.ts`) and the query builder that acts on it
// (`trpc/routes/search/load`).
export const SEARCH_MODES = ["free", "photographer", "title", "location"];
/** The default, and the behaviour that existed before the dropdown: image embeddings. */
export const DEFAULT_SEARCH_MODE = "free";
export const SEARCH_MODE_LABELS = {
    free: "Free text",
    photographer: "Photographer",
    title: "Artwork title",
    location: "Location",
};
/** Placeholder per mode — "drop an image" is only true of the free-text one. */
export const SEARCH_MODE_PLACEHOLDERS = {
    free: "Type or drop an image to search",
    photographer: "Search by photographer name",
    title: "Search in artwork titles",
    location: "Search by place, city or country",
};
export function isSearchMode(value) {
    return SEARCH_MODES.includes(value);
}
/** Narrow an untrusted value to a mode, falling back to today's behaviour. */
export function toSearchMode(value) {
    return value && isSearchMode(value) ? value : DEFAULT_SEARCH_MODE;
}
/**
 * The URL path segment that carries a non-default mode.
 *
 * Browse URLs are `/search/<query>/<segment>/<segment>…`, where each segment is a filter
 * option id — so the mode rides in the same way every other filter already does, and a
 * copied link reopens the same view. The default mode emits nothing, which keeps an
 * ordinary free-text URL byte-identical to what it was before the dropdown existed.
 *
 * `mode-` cannot collide with a filter option id: those are `sort-*`, `artist-country-*`,
 * colour names and category slugs, none of which start with it.
 */
export function searchModeSegment(mode) {
    return mode === DEFAULT_SEARCH_MODE ? "" : `mode-${mode}`;
}
/** The mode a Browse URL's path segments ask for. */
export function searchModeFromSegments(segments) {
    for (const m of SEARCH_MODES) {
        if (m !== DEFAULT_SEARCH_MODE && segments.some((s) => s.trim() === `mode-${m}`))
            return m;
    }
    return DEFAULT_SEARCH_MODE;
}
//# sourceMappingURL=searchMode.js.map